module.exports = {"150521100":"保康镇","150521101":"宝龙山镇","150521102":"舍伯吐镇","150521103":"巴彦塔拉镇","150521104":"门达镇","150521105":"架玛吐镇","150521106":"腰林毛都镇","150521107":"希伯花镇","150521108":"花吐古拉镇","150521109":"代力吉镇","150521110":"努日木镇","150521200":"花胡硕苏木乡","150521201":"协代苏木乡","150521202":"白兴吐苏木乡","150521203":"图布信苏木乡","150521204":"敖包苏木","150521205":"胜利乡","150521400":"白音塔拉农场","150521401":"珠日河牧场","150521402":"丰库牧场","150521403":"保康街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150521.json
// module id = 516
// module chunks = 0